import { controlSizeFallback, cssControlSize, cssSpacing, slControlSize } from "../../styles/index.mjs";
import { Text } from "../Text/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Label = styled(Text).withConfig({
  displayName: "Label",
  componentId: "sc-k61801-0"
})(["", ";"], function (_ref) {
  var $chipSize = _ref.$chipSize;
  return css(["min-inline-size:", ";padding-inline-start:", ";padding-inline-end:", ";"], cssControlSize(slControlSize($chipSize), controlSizeFallback[$chipSize]), $chipSize === 'medium' ? "".concat(cssSpacing('tighter-2', '8px')) : "".concat(cssSpacing('tighter-3', '6px')), $chipSize === 'medium' ? "".concat(cssSpacing('tighter-2', '8px')) : "".concat(cssSpacing('tighter-3', '6px')));
});